<template>
    <div>
        <div class="mb-5 pb-5">
            <!-- shape Hero -->
            <section class="section-shaped my-0 pb-lg-5">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  ">Your Cart
                                </h1>
                                <div v-if="OrderListData.length<=0">
                                    <p >Your cart is currently empty.</p>
                                </div>
                                <router-link :to="{ name: 'catalog'}"
                                class="border-0 p-0 ">
                                    <span class="nav-link-inner--text"><u>Continue Shopping</u></span>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
            <div class="container cart-custom-height">
                <section class="section section-lg pt-lg-0 pb-4" v-bind:style=" { height:OrderListData.length<=0 ? '33vh' : OrderListData.length==1 ? '30vh' : ''}">
                    <div v-if="OrderListData.length>0" class="card p-3">
                        <div class="row justify-content-center">
                            <div class="col-lg-12">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Product</th>
                                                <th>Price</th>
                                                <th>Quantity</th>
                                                <th>Subtotal</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(order, orderIndex) in OrderListData">
                                                <td>
                                                    <span>{{order.name}}</span><br>
                                                    <span v-if="order.matrix_parent_id!=null && order.matrix_parent_id!=-1 && order.matrix_parent_id!=''">
                                                        <small v-if="order.color_name!=null && order.color_id!=null">Color : {{order.color_name}}</small><br>
                                                        <small v-if="order.size_name!=null && order.size_id!=null">Size : {{order.size_name}}</small><br>
                                                        <small v-if="order.design_name!=null && order.design_id!=null">Design : {{order.design_name}}</small><br>
                                                    </span>
                                                    <a-popconfirm class="border-0 p-0" title="You are about to delete this record?" @confirm="deleteOrder(orderIndex)" okText="Remove" cancelText="Cancel">
                                                        <a-button class="border-0 p-0 text-primary">
                                                            <u>Remove</u>
                                                        </a-button>
                                                    </a-popconfirm>
                                                </td>
                                                <td>{{ formatPrice(order.retail_price) }}</td>

                                                <td>
                                                    <a-input-number v-model="order.quantity" @change="updateQty(order.quantity,orderIndex)" :min="1" />
                                                </td>
                                                <td>{{formatPrice(order.retail_price*order.quantity)}}</td>
                                            </tr>
                                            <tr >
                                                <td colspan="3" align="right"><h5>Total</h5></td>
                                                <td align="left">{{formatPrice(totalItem())}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="m-0 pt-3 pb-2">
                            <base-button type="primary" class="text-uppercase float-right" @click.prevent="checkout">checkout
                            </base-button>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>
<script>
import secureStorage from '../../controllers/secureStorage.js'
import HTTPRequest from '../../controllers/httpRequest.js'
import { mapState, mapActions } from 'vuex'
export default {
    components: {
        HTTPRequest
    },
    computed: {
        ...mapState(['endPoint', 'parameters'])
    },
    data() {
        return {
            OrderListData:[],
            totalAmount:0,
            storeDetails:[],
            customerLoginStatus:false,
        }
    },
    mounted: async function(){
        var autoLogin = secureStorage.getItem("ecomLoggedIn")
        if(autoLogin == true){
            this.$emit('showFooterAndHeader', event)
            this.$emit('hideSearchInput', event)
            this.storeDetails = secureStorage.getItem("SalesChannelDetails")
            this.customerLoginStatus = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus")
            this.OrderList()
        }else{
            this.$router.push({ name: 'loading_screen', params: { returnUrl: 'cart', storeId:this.$route.params.storeId }})
        }
    },
    methods:{
        OrderList: async function(){
            if (this.customerLoginStatus){
                var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channel_cart_items?account_id='+this.storeDetails.account_id+'&sales_channel_id='+this.storeDetails.id+'&customer_id='+secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin").id, null)
                console.log(response)
                this.OrderListData = response;
            }else{
                var gData = secureStorage.getItem("OrderListData"+this.storeDetails.name);
                if (gData !='' && gData !=null){
                    this.OrderListData = gData;
                    this.totalAmount = 0;
                }
            }
        },
        deleteOrder:async function(index){
            if (this.customerLoginStatus){
                var id = this.OrderListData[index].sales_channel_cart_item_id
                var response = await HTTPRequest.destroyRequest(this.endPoint + 'sales_channel_cart_items/'+id, null, null)
                if (response["error"] == undefined){
                    await this.OrderList()
                    this.$emit('getOrderCount', this.OrderListData)
                }
            }else {
                this.OrderListData.splice(index,1)
                secureStorage.setItem("OrderListData"+this.storeDetails.name,this.OrderListData)
                this.$emit('getOrderCount', this.OrderListData)
                this.OrderList()
            }
        },
        formatPrice: function(value) {
            let val = (value/1).toFixed(2).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        totalItem: function(){
            let sum = 0;
            for(let i = 0; i < this.OrderListData.length; i++){
                sum += (parseFloat(this.OrderListData[i].retail_price) * parseFloat(this.OrderListData[i].quantity));
            }
            return sum;
        },
        updateQty:async function(quantity,index){
            if (this.customerLoginStatus){
                var id = this.OrderListData[index].id
                var put_request = await HTTPRequest.putRequest(this.endPoint + 'sales_channel_cart_items/' +id, null, {quantity:quantity}) 
                if (put_request["error"] == undefined){
                    await this.OrderList()
                    this.$emit('getOrderCount', this.OrderListData)
                }
            } else {
                secureStorage.setItem("OrderListData"+this.storeDetails.name,this.OrderListData)
                this.$emit('getOrderCount', this.OrderListData)
                this.OrderList()
            }
        },
        checkout: function(){
            secureStorage.setItem("CheckoutOrderListData"+this.storeDetails.name,this.OrderListData)
            this.$router.push({ name: 'checkout'})
        }
    }
};
</script>
<style>
@media (max-width: 767.98px){
    .cart-custom-height {
       height: 40vh;
    }
}
</style>